import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _22mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"22mp"}/>
}
